import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modify-availability__selectable-item-content" }
const _hoisted_2 = { class: "modify-availability__selectable-item-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["selected", "value"]

import {computed, PropType} from 'vue';
    import {AvailabilityFrequencyResource} from '@/common/api';
    import {UpdateAvailability} from '@/logged/features/header-menu/composables/useAvailability';
    import {isSameDay, addYears, addDays} from 'date-fns';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ModifyAvailability',
  props: {
        state: {type: Object as PropType<UpdateAvailability>, required: true},
        radiosDirection: {type: String as PropType<'horizontal' | 'vertical'>, required: true},
        showCalendarRelative: {type: Boolean, default: false},
    },
  emits: ["stateUpdated", "calendarToggled"],
  setup(__props, { emit }) {

const props = __props;

    

    const frequencies = [
        'FULL_TIME',
        'EVENINGS_AND_WEEKENDS',
        'FOUR_DAYS_PER_WEEK',
        'THREE_DAYS_PER_WEEK',
        'TWO_DAYS_PER_WEEK',
        'ONE_DAY_PER_WEEK',
    ] as AvailabilityFrequencyResource[];
    const months = [1, 3, 6];

    

    function availabilityUpdate(event: CustomEvent) {
        const {value} = event.detail;
        emit('stateUpdated', {value});
    }

    function frequencyUpdate(event: CustomEvent) {
        const {value} = event.detail;
        emit('stateUpdated', {frequency: value});
    }

    function onCalendarToggle(value: boolean) {
        emit('calendarToggled', value);
    }

    function nextAvailabilityDateUpdate(value: Date) {
        emit('stateUpdated', {nextAvailabilityDate: value});
    }

    function nextAvailabilityDateUpdateByMonth(event: CustomEvent) {
        if (!event.detail.value) {
            return;
        }
        const month = Number(event.detail.value);
        const now = new Date();
        now.setMonth(now.getMonth() + month);
        emit('stateUpdated', {...props.state, nextAvailabilityDate: now});
    }

    const isNotAvailable = computed(() => props.state.value === 'NOT_AVAILABLE');
    const isAvailable = computed(() => props.state.value === 'AVAILABLE');

    const nextAvailabilityDateByMonthSelected = computed(() => {
        if (!props.state.nextAvailabilityDate) {
            return undefined;
        }

        for (const numberOfMonth of months) {
            const now = new Date();
            now.setMonth(now.getMonth() + numberOfMonth);
            if (isSameDay(now, props.state.nextAvailabilityDate)) {
                return numberOfMonth;
            }
        }

        return undefined;
    });

    function minDateForAvailabilityInput() {
        return addDays(new Date(), 1);
    }

    function maxDateForAvailabilityInput() {
        return addYears(new Date(), 3);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!
  const _component_joy_label = _resolveComponent("joy-label")!
  const _component_joy_radio = _resolveComponent("joy-radio")!
  const _component_joy_radio_group = _resolveComponent("joy-radio-group")!
  const _component_VJoyCalendar = _resolveComponent("VJoyCalendar")!
  const _component_joy_select = _resolveComponent("joy-select")!
  const _component_joy_wrapper = _resolveComponent("joy-wrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_joy_wrapper, {
      class: "modify-availability",
      align: "stretch",
      direction: "column",
      wrap: "nowrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_joy_selectable_item_group, {
            "full-width": "",
            onJoySelectableItemGroupChange: availabilityUpdate
          }, {
            default: _withCtx(() => [
              _createVNode(_component_joy_selectable_item, {
                "data-testid": "navbar-availability-set-available-no",
                value: "NOT_AVAILABLE",
                checked: isNotAvailable.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, [
                    _createVNode(_component_joy_icon, { name: "ban" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$msg('profile.availability.edit.NOT_AVAILABLE')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_joy_selectable_item, {
                "data-testid": "navbar-availability-set-available-yes",
                value: "AVAILABLE",
                checked: isAvailable.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, [
                    _createVNode(_component_joy_icon, { name: "check" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$msg('profile.availability.edit.AVAILABLE')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["checked"])
            ]),
            _: 1
          })
        ]),
        (isNotAvailable.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_joy_label, { class: "modify-availability__label" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$msg('profile.availability.modify.next.availability.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_joy_radio_group, {
                direction: __props.radiosDirection,
                value: nextAvailabilityDateByMonthSelected.value,
                onJoyRadioGroupValueChange: nextAvailabilityDateUpdateByMonth
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (item) => {
                    return _createVNode(_component_joy_radio, {
                      "data-testid": "navbar-set-availability-by-month",
                      key: item,
                      value: item
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$icu('profile.availability.edit.next.availability.date.choice', {count: item})), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["direction", "value"]),
              _createVNode(_component_VJoyCalendar, {
                "data-testid": "navbar-date-picker",
                id: "nextAvailabilityDate",
                class: _normalizeClass(["modify-availability__calendar", {'modify-availability__calendar--relative': __props.showCalendarRelative}]),
                modelValue: __props.state.nextAvailabilityDate,
                datePatternRegex: _ctx.$msg('generic.form.date.pattern'),
                datePattern: _ctx.$msg('generic.form.date.java.pattern'),
                placeholder: _ctx.$msg('generic.form.date.human.pattern'),
                minDate: minDateForAvailabilityInput(),
                maxDate: maxDateForAvailabilityInput(),
                "onUpdate:modelValue": nextAvailabilityDateUpdate,
                onToggled: onCalendarToggle
              }, null, 8, ["class", "modelValue", "datePatternRegex", "datePattern", "placeholder", "minDate", "maxDate"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_joy_label, { class: "modify-availability__label" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$msg('profile.availability.modify.frequency.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_joy_select, {
                "data-testid": "navbar-set-availability-frequency",
                onJoySelectChange: frequencyUpdate
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(frequencies, (frequency) => {
                    return _createElementVNode("option", {
                      selected: __props.state.frequency === frequency,
                      value: frequency
                    }, _toDisplayString(_ctx.$msg(`profile.frequency.text.${frequency}`)), 9, _hoisted_5)
                  }), 64))
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})